module.exports = __webpack_public_path__ + "static/media/conta_energia.eb6161c7.png";